export default __webpack_public_path__ + "static/media/appstore_us_badge_web.855c0139.png";